import {Component, OnInit} from "@angular/core";
import {FormBuilder} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {Animations,
    BackendOberflaecheService,
    ProgressManagerService,
    DownloadService,
    DankeComponent,
    ClientDownloadService,
    TarifrechnerAppConfiguration
} from "@vhv/tarifrechner-common";
import { CyberBetriebsartComponent } from '../betriebsart/cyber-betriebsart.component';


@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: "cyber-danke.component.html"
})
export class CyberDankeComponent extends DankeComponent implements OnInit{

    ngOnInit(): void {
        super.ngOnInit();
        window.removeEventListener("beforeunload", CyberBetriebsartComponent.createMessageBeforeUnload);
    }

}
